<script>
  import {
    VContent
  } from 'vuetify/lib'
  export default {
    name: 'wh-content',
    extends: VContent
  };
</script>